interface BrandFormValues {
  name?: string;
  isGame?: boolean;
  gameId?: string | number;
}

export default function validate(values: BrandFormValues) {
  const errors: Record<string, string> = {};

  if (!values.name) {
    errors.name = "Brand name is required";
  }

  return errors;
}
